var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'status-label inline-flex h-6 items-center rounded-full px-2 text-xs font-medium',
    { 'bg-primary-50 text-primary-600': _vm.status === 'OPEN' },
    { 'bg-neutral-50 text-neutral-600': _vm.status === 'CLOSED' },
    { 'bg-success-50 text-success-600': _vm.status === 'ACCEPTED' },
    { 'bg-danger-50 text-danger-600': _vm.status === 'DECLINED' } ]},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }